import { render } from "./SingleIceCream.vue?vue&type=template&id=8dec4fd8"
import script from "./SingleIceCream.vue?vue&type=script&lang=js"
export * from "./SingleIceCream.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__